<template>
    <LoadingBoxTransition :error-box="errorBox" :view="true" :loading="loading">
        <slot />
    </LoadingBoxTransition>
</template>

<script lang="ts" setup>
import type { ErrorBox } from '../errors/ErrorBox';
import LoadingBoxTransition from './LoadingBoxTransition.vue';

withDefaults(
    defineProps<{
        errorBox?: ErrorBox | null;
        loading?: boolean;
    }>(),
    {
        errorBox: null,
        loading: false,
    },
);

</script>
